module.exports = __webpack_public_path__ + "img/BG1.ca8c26ec.png";